import { IconButton, Tooltip } from '@material-ui/core'
import DeleteIcon from '@material-ui/icons/Delete'
import CopyIcon from '@material-ui/icons/FileCopy'
import { useState } from 'react'

import { gregorianToJalaali } from '../../helpers/date'
import { getTranslate, lang } from '../../localization'
import { ChannelAPIKeys } from '../../types/channelAPIKeys'
import useStyles from './index.styles'

interface UserAPIKeyRowProps {
  data: ChannelAPIKeys
  deleteFunction: (input: ChannelAPIKeys, index: number) => void
  pendingForDeletion: boolean
  currentID: string
  index: number
  hasAccessToModifyChannelApiKeys?: boolean | undefined
}

const UserAPIKeyRow: React.FC<UserAPIKeyRowProps> = ({
  data,
  deleteFunction,
  pendingForDeletion,
  currentID,
  index,
  hasAccessToModifyChannelApiKeys
}) => {
  const classes = useStyles()

  const [toolTipIsOpen, settoolTipIsOpen] = useState(false)

  const copyAPIKey = () => {
    window.navigator.clipboard.writeText(data.key)
  }

  return (
    <div className={classes.tableRow}>
      <div className={classes.expireDateCell}>
        {lang === 'fa' ? gregorianToJalaali(data.expiresAt) : data.expiresAt}
      </div>
      <div className={classes.APIKeyCell}>
        <span>{data.key}</span>
        <div className={classes.copiedIconCell}>
          <Tooltip
            onClose={() => settoolTipIsOpen(false)}
            open={toolTipIsOpen}
            placement="left"
            title={getTranslate('Copied to Clipboard')}>
            <IconButton
              onClick={() => {
                copyAPIKey()
                settoolTipIsOpen(true)
              }}
              className={classes.copyIconButton}>
              <CopyIcon />
            </IconButton>
          </Tooltip>
        </div>
      </div>
      <div className={classes.descriptionCell}>{data.description}</div>
      <div className={classes.deleteIconCell}>
        <IconButton
          onClick={() => deleteFunction(data, index)}
          disabled={
            (pendingForDeletion && currentID === data.id) ||
            !hasAccessToModifyChannelApiKeys
          }>
          <DeleteIcon />
        </IconButton>
      </div>
    </div>
  )
}

export default UserAPIKeyRow
